<template>
  <div class="page-container pt-3 pb-4 profile-page" v-if="$store.getters['auth/isLoggedIn']">
    <UpdateProfile v-if="$store.getters['auth/user']" />

    <FollowingSpeakers />
    <div class="mb-5"></div>
    <SavedShiurim />
    <div class="mb-5"></div>
    <InProgressShiurim />
  </div>
</template>

<script>
import SavedShiurim from './SavedShiurim.vue';
import InProgressShiurim from './InProgressShiurim.vue';
import FollowingSpeakers from './FollowingSpeakers.vue';
import UpdateProfile from './UpdateProfile.vue';

export default {
  components: {
    SavedShiurim,
    FollowingSpeakers,
    UpdateProfile,
    InProgressShiurim,
  },
  i18nOptions: {
    namespaces: 'pages',
    keyPrefix: 'profile',
  },
  mounted() {
    if (!this.$store.getters['auth/isLoggedIn']) {
      this.$router.push('/');
      this.$store.dispatch('auth/showModal');
    }
  },
};
</script>

<style></style>
